module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaAQMAAACThN6NAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRF////AAAAVcLTfgAAAAJ0Uk5TgABNEFVzAAAAGUlEQVR4nGNgPvCBgQEn8f///wPoBJV1AABe9jx/iYRDpwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/base-title-icon-2.png
// module id = 9bgh
// module chunks = 0